import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Adana daire temizliği hizmeti",
  heroDescription: "Evinizi hijyenik, düzenli ve ferah hale getiren profesyonel daire temizliği hizmeti. Sarıçam ve Adana geneline düzenli temizlik çözümleri.",
  description: "Evler, gün içinde en çok zaman geçirilen yaşam alanlarıdır. Bu nedenle düzenli ve detaylı temizlik, hem konfor hem de hijyen açısından büyük önem taşır. Day Temizlik Adana, daire temizliği hizmetinde evinizin ihtiyaçlarına uygun planlama yaparak mutfak, banyo, salon, odalar, zeminler ve genel yüzeylerde titiz bir temizlik süreci uygular. Her oda için farklı temizlik adımları belirler, kullanılacak ekipman ve malzemeleri mekanın yapısına göre seçer. Daire temizliği hizmetimizde Adana temizlik firması arayışlarınıza profesyonel ve güvenilir yanıt veriyoruz.",
  scope: [
    "Mutfak yüzey temizliği",
    "Banyo ve tuvalet temizliği",
    "Zemin süpürme ve silme",
    "Cam ve uygun yüzey temizliği",
    "Toz alma",
    "Kapı, dolap dış yüzeyleri ve genel alan temizliği",
    "Yaşam alanlarının kullanıma hazır hale getirilmesi",
  ],
  forWho: [
    "Ev sahipleri",
    "Kiracılar",
    "Günlük temizlik isteyenler",
    "Özel gün öncesi temizlik isteyenler",
    "Taşınma öncesi ve sonrası temizlik ihtiyacı olanlar",
    "Eşyalı ev temizliği isteyenler",
  ],
  process: [
    "İhtiyacınızı dinleyerek alan büyüklüğü ve temizlik yoğunluğunu belirliyoruz.",
    "Evinizin yapısına ve mevcut durumuna göre ekipman seçimi yapıyoruz.",
    "Oda odada detaylı temizlik planı oluşturuyoruz.",
    "Profesyonel ekibimizle belirlenen süreçte temizliği uyguluyoruz.",
    "Son kontrolü yaparak alanı size teslim ediyoruz.",
  ],
  whyProfessional: [
    "Profesyonel ekipman ve doğru temizlik maddeleri kullanılır.",
    "Detaylı temizlik anlayışıyla yüzeylerdeki kir ve toz etkili şekilde temizlenir.",
    "Zamanında hizmet sayesinde günlük planlarınız aksamaz.",
    "Alanın yapısına uygun planlama yapılarak her köşe değerlendirilir.",
    "Hijyen odaklı süreçle yaşam alanlarınız daha sağlıklı hale gelir.",
  ],
  relatedServices: [
    { title: "Koltuk Yıkama", path: "/hizmetlerimiz/koltuk-yikama" },
    { title: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama" },
    { title: "İnşaat Sonrası Temizlik", path: "/hizmetlerimiz/insaat-sonrasi-temizlik" },
  ],
  faqs: [
    { question: "Daire temizliği ne kadar sürer?", answer: "Daire temizliği süresi, mekanın büyüklüğüne ve temizlik ihtiyacına göre değişir. Genel olarak 2+1 bir daire 2-3 saat, 3+1 bir daire 3-4 saat sürebilir." },
    { question: "Temizlik malzemeleri sizin tarafınızdan getiriliyor mu?", answer: "Evet, hizmet sırasında gerekli temizlik malzemeleri ve ekipmanlar ekibimiz tarafından getirilir." },
    { question: "Aynı gün randevu alınabilir mi?", answer: "Acil durumlarda ve müsaitlik durumuna göre aynı gün hizmet almanız mümkün olabilir." },
  ],
  ctaText: "Eviniz için profesyonel temizlik randevusu oluşturun.",
  heroImage: "/assets/images/daire-temizligi.jpg",
};

export default function DaireTemizligiPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}